import Link from "src/icons/link.inline.svg";
import SvgIcon from "./SvgIcon";

export default SvgIcon(Link);
